import { render } from "./SubmitNoBidInviteModal.vue?vue&type=template&id=65addbaa"
import script from "./SubmitNoBidInviteModal.vue?vue&type=script&lang=js"
export * from "./SubmitNoBidInviteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__